
export const styles = theme => ({  
    icon: {
      fontSize: 40,
      float : 'right',
      cursor : 'pointer'
    },
    headerImage: {
      marginBottom: theme.spacing(12),
      position: 'relative'
    },
    containerImage: {
      width: '100%'
    },
    image: {
      width: '100%',
      objectFit: "cover",
    },
    camera: {
      display: 'none'
    },
    boxAvatar: {
      position: 'absolute',
      bottom: '-1rem',
      left: theme.spacing(3),
    },
    avatar: {
        // marginRight: theme.spacing(3),
    },
    text: {
        paddingTop: theme.spacing(2),
        marginLeft: '15rem',
        display: 'flex',
        justifyContent: 'space-between'
    }
});